import { combineValidators, hasLengthGreaterThan, isRequiredIf } from "revalidate";
import { number, object, string } from "yup";
/* .../max is required to use the most accurate validation available */
import { validatePhoneIntl } from "app/utils/utils";

export const validatePhoneNumberType = phoneNumberIntl => {
	if (typeof phoneNumberIntl !== "string") {
		return true; // if user wants to empty his number input it can be undefined
	}
	const isMatching = validatePhoneIntl(phoneNumberIntl);

	return isMatching;
};

export const fields = [
	"name.firstName",
	"name.lastName",
	"name.gender",
	"birthDate.day",
	"birthDate.month",
	"birthDate.year",
	"nationality",
	"address.line1",
	"address.line2",
	"address.postCode",
	"address.city",
	"address.country",
	"address.phone",
	"passport.passportNumber",
	"passport.countryIssue",
	"passport.passportExpirationDate",
];

export const validate = combineValidators({
	name: {
		firstName: hasLengthGreaterThan(1)({
			message: { id: "error.firstName.minlength" },
		}),
		lastName: hasLengthGreaterThan(1)({
			message: { id: "error.lastName.minlength" },
		}),
	},
	birthDate: {
		day: isRequiredIf(values => values && (values.birthDate.month || values.birthDate.year))({
			message: { id: "error.birthdate.day" },
		}),
		month: isRequiredIf(values => values && (values.birthDate.day || values.birthDate.year))({
			message: { id: "error.birthdate.month" },
		}),
		year: isRequiredIf(values => values && (values.birthDate.day || values.birthDate.month))({
			message: { id: "error.birthdate.year" },
		}),
	},
});

export const defaultValues = {
	"honorific-prefix": "",
	"family-name": "",
	"given-name": "",
	birthdateDay: "",
	birthdateMonth: "",
	birthdateYear: "",
	nationality: "",
	"address-line1": "",
	"address-line2": "",
	"postal-code": "",
	"address-level2": "", // city
	"country-name": "",
	phone: "",
	// TODO SMS-OPTIN
	// phonemobile: "",
};

export const validationSchema = object().shape(
	{
		"family-name": string().min(2, { id: "error.lastName.minlength" }),
		"given-name": string().min(2, { id: "error.firstName.minlength" }),
		birthdateDay: number().when(["birthdateMonth", "birthdateYear"], {
			is: (month, year) => month || year,
			then: number().required({ id: "error.birthdate.day" }),
		}),
		birthdateMonth: number().when(["birthdateDay", "birthdateYear"], {
			is: (day, year) => day || year,
			then: number().required({ id: "error.birthdate.month" }),
		}),
		birthdateYear: number().when(["birthdateDay", "birthdateMonth"], {
			is: (day, month) => day || month,
			then: number().required({ id: "error.birthdate.year" }),
		}),
		phone: string().test(
			"phone (mobile or a fixed-line number)",
			{ id: "error.phone.invalid" },
			numberIntl => validatePhoneNumberType(numberIntl)
		),
		// TODO SMS-OPTIN reactivate to enable validation
		// phone: string()
		// 	.test(
		// 		"should not be a mobile phone number",
		// 		validationMessages.phoneFixedIsMobile,
		// 		numberIntl =>
		// 			validatePhoneNumberType(
		// 				numberIntl,
		// 				[LIB_PHONE_NUMBER_TYPES.PERSONAL_NUMBER, LIB_PHONE_NUMBER_TYPES.MOBILE],
		// 				false
		// 			)
		// 	)
		// 	.test("should be a fixed-line number", validationMessages.phoneInvalid, numberIntl =>
		// 		validatePhoneNumberType(numberIntl, [
		// 			LIB_PHONE_NUMBER_TYPES.FIXED_LINE,
		// 			LIB_PHONE_NUMBER_TYPES.FIXED_LINE_OR_MOBILE,
		// 			LIB_PHONE_NUMBER_TYPES.UNDEFINED,
		// 		])
		// 	),
		// phonemobile: string()
		// 	.test(
		// 		"should not be a fixed-line number",
		// 		validationMessages.phoneMobileIsFixed,
		// 		numberIntl =>
		// 			validatePhoneNumberType(numberIntl, [LIB_PHONE_NUMBER_TYPES.FIXED_LINE], false)
		// 	)
		// 	.test("should be a mobile phone number", validationMessages.phoneInvalid, numberIntl =>
		// 		validatePhoneNumberType(numberIntl, [
		// 			LIB_PHONE_NUMBER_TYPES.PERSONAL_NUMBER,
		// 			LIB_PHONE_NUMBER_TYPES.MOBILE,
		// 			LIB_PHONE_NUMBER_TYPES.FIXED_LINE_OR_MOBILE,
		// 			LIB_PHONE_NUMBER_TYPES.UNDEFINED,
		// 		])
		// 	),
	},
	[
		["birthdateDay", "birthdateMonth"],
		["birthdateDay", "birthdateYear"],
		["birthdateMonth", "birthdateYear"],
	]
);
